module.exports = __webpack_public_path__ + "static/media/physics.2f31013f.png";